module.exports = __webpack_public_path__ + "assets/img/jiantou.2583ae62.svg";